import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const generateProviderPaymentAttachmentUploadPresignedUrl = async (
  homeServiceOrderId: number,
  contentType: string,
  fileName: string,
) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: { homeServiceOrderId, contentType, fileName },
    query: graphql(`
      query generateProviderPaymentAttachmentUploadPresignedUrl($homeServiceOrderId: Float!, $contentType: String!, $fileName: String!) {
        generateProviderPaymentAttachmentUploadPresignedUrl(
          homeServiceOrderId: $homeServiceOrderId
          contentType: $contentType
          fileName: $fileName
        ) {
          url
          key
        }
      }
    `),
  });

  return response.data.generateProviderPaymentAttachmentUploadPresignedUrl;
};
